module.exports = __webpack_public_path__ + "img/sp-icon-delete-img.100e06fe.svg";